export const S3_IMAGES_URL = 'https://static.solartrip.com/images/solar_cash_landing/';
export const S3_MP4_URL = 'https://static.solartrip.com/mp4/solar_cash_landing/';
export const APP_LINK = 'https://slr.onelink.me/gEAA/fpxa1zgj';
